import { Checkbox, Grid, List, ListItem, ListItemIcon, Paper, Typography } from "@mui/material";

import { Link, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { dark_blue, linkStyle } from "../../theme";
import { selectCheckbox1, selectCheckbox2, selectCheckbox3, setCheckbox1, setCheckbox2, setCheckbox3, setConsent } from "../Registration/RegistrationSlice";
import { ActionButton } from "../ActionButton/ActionButton";


export function ConsentRegistration() {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const checkbox1 = useAppSelector(selectCheckbox1);
    const checkbox2 = useAppSelector(selectCheckbox2);
    const checkbox3 = useAppSelector(selectCheckbox3);

    const style={
        textAlign: "justify",
        color: dark_blue ,
        fontSize: 25

    }

    useEffect(() => {
        if (!checkbox1 || !checkbox2 || !checkbox3) dispatch(setConsent(false));
    }, [checkbox1, checkbox2, checkbox3]);

    return (
        <Grid
            sx={{ mt: '10em', mb:'8em' }}
            container
            justifyContent="center" 
    spacing = {3}

        >
            <Grid item lg={10}  sm={6}>
                <Typography variant="h5" sx={{...style, textAlign: 'center', fontWeight: "bold",}}>
                    EAP CONSENT
                </Typography>
            </Grid>
            <Grid item  sm={10} style={{ padding: 20, margin: "0px, auto" }}>
                <Paper style={{ padding: 50 }}>
                    <Grid container style={{}} spacing={3} justifyContent='center' textAlign='justify'>
                        <Grid item>
                            <Typography color={dark_blue} sx={{ fontSize: 30, fontWeight: "bold", textAlign:'justify' }}>
                                Please review the consent form and select the checkboxes below to continue

                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography  sx={style}>

                                I understand that the documents and information I submit on this Portal will contain my personal data, and may also include the following categories of personal information: name, address, age, date of birth, gender, education, profession, banking information, personal data revealing racial or ethnic origin, political or ideological opinions, religious beliefs or union membership and data concerning health.

                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography sx={style}>
                                I understand that the information concerning me collected on this Portal, and the information concerning other individuals referred to in my submissions, including my family, guardian, or doctor (“Third Parties”) will be processed in accordance with Claims Conference privacy notice which can be found at

                                <a href="https://www.claimscon.org/about/privacy-policy/"> privacy policy</a>.
                                I confirm that I have made these Third Parties aware of this notice and have their permission for the Claims Conference, and any third parties set out in the notice, to process their personal information in this application form.


                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography sx={style}>
                                The processing of this data serves the purpose of processing my request for benefits under one or more of the Claims Conference compensation funds, which includes the Article 2 Fund, the Central Eastern European Fund, Region Specific Persecution Pension Program, the Child Survivor Fund, the Kindertransport Fund, the Hardship Fund, Hardship Fund Supplemental, and Spouse of Holocaust Survivor Fund.

                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography sx={style}>
                                I agree that personal data processed in connection with my application may be transferred to Claims Conference offices, including but not limited to offices in the U.S., Germany and Israel. Those countries may have data protection rules that are different from those of my country. I also agree that my personal data may be provided to the German Ministry of Finance and the German Federal Audit Office solely for review and audit purposes and in the framework of the data protection provisions of the Federal Republic of Germany.


                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography sx={style}>
                                Information relating to my ethnic and racial origins, political or ideological opinions, religious beliefs, union membership, and health is considered to be special category data under European data protection law (“Sensitive Personal Data”). We require your express consent under European data protection law to process Sensitive Personal Data.


                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography sx={style}>

                                By checking the boxes below, I hereby expressly accept that in order to determine my eligibility for the compensation program and receive payment:

                            </Typography>
                        </Grid>
                        <Grid item>
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <Checkbox
                                            checked={checkbox1}
                                            onChange={(e: any) => {
                                                dispatch(setCheckbox1(!checkbox1));
                                            }}
                                        />
                                    </ListItemIcon>
                                    <Typography color={dark_blue} sx={{ fontSize: 25, fontWeight: "bold", textAlign: 'left' }}>

                                        My Sensitive Personal Data shall be processed by the Claims Conference to determine my eligibility for benefits from the Claims Conference compensation programs specified above.

                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <Checkbox
                                            checked={checkbox2}
                                            onChange={(e: any) => {
                                                dispatch(setCheckbox2(!checkbox2));
                                            }}
                                        />
                                    </ListItemIcon>
                                    <Typography  sx={{...style, fontWeight: 'bold', textAlign: 'left'}}>

                                        My Sensitive Personal Data shall be shared with the German Ministry of Finance/Federal Audit Office.

                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <Checkbox
                                            checked={checkbox3}
                                            onChange={(e: any) => {
                                                dispatch(setCheckbox3(!checkbox3));
                                            }}
                                        />
                                    </ListItemIcon>
                                    <Typography sx={{...style, fontWeight: 'bold', textAlign: 'left'}}>

                                        As needed, my personal data and Sensitive Personal Data collected in this form shall be transferred outside of the European Economic Area and/or the UK.

                                    </Typography>
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item>
                            <Typography sx={{...style, fontWeight: 'bold', textAlign: 'justify'}}>
                                In addition, I agree that the Claims Conference may use the personal information submitted on this Portal in order to provide me with additional information regarding compensation programs or social welfare benefits that are available to Nazi victims. The Claims Conference recognizes my rights in relation to my personal information as set forth in the Claims Conference privacy notice at

                                <a href="https://www.claimscon.org/about/privacy-policy/"> Privacy Policy</a>.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography sx={style}>
                                I understand I have the right to withdraw my consent at any time. To withdraw my consent, to exercise my rights under the privacy notice or to make any complaints I understand I should contact The Claims Conference at privacy@claimscon.org or PO Box 1215, New York, New York 10113. The revocation of consent shall not affect the lawfulness of the processing which has been carried out on the basis of the consent until its revocation. If I withdraw my consent, I understand that the Claims Conference may not be able to process my application or comply with its obligations required to make any payment.

                            </Typography>
                        </Grid>
                        <Grid item sm={10}>
                            <Typography sx={{...style, textAlign: 'center'}}>
                                I have read and agree to the above.
                            </Typography>
                        </Grid>
                        <ActionButton
                            disabled={checkbox1 && checkbox2 && checkbox3 ? false : true}
                            name="proceed with registration"
                            local_error=""
                            action={() => {
                                dispatch(setConsent(true));
                                history.push("/registration");
                            }}
                        />
                        <Grid item>
                            <Typography sx={{...style, fontSize: 30, fontWeight: 'bold'}}>
                                Please review the consent form and select the checkboxes above to continue
                            </Typography>
                        </Grid>
                        <Grid textAlign="center" item xl={8} lg={8} md={12} sm={12} xs={12}>
                            <Link style={linkStyle} to="/registration">
                                {/* @ts-ignore */}
                                Go Back
                            </Link>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid >
    );
}


